import React from 'react';
import cx from 'classnames';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  children: React.ReactNode | string;
  className?: string;
}

const BannerAlert: React.FC<Props> = (props) => {
  return (
    <div
      className={cx(style.banner, props.className, 'u-padding-A-xs')}
      style={{
        backgroundColor: colors.yellowLight,
        borderColor: colors.yellow,
        borderWidth: '0px 0px 2px',
        borderStyle: 'solid',
        color: colors.textColor
      }}
    >
      {typeof props.children === 'string' ? <span dangerouslySetInnerHTML={{__html: props.children }} /> : props.children}
    </div>
  );
};

export default BannerAlert;
